function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { ManifestComponentExtensionType } from '../ManifestStore';
import { ManifestContextAPI } from './ManifestContextAPI';
import { getEmptyManifest, getEmptyManifestContext } from './ManifestRuntimeContext';
import { hash } from '../hash';
import { StandaloneManifestRuntimeContextBuilder } from './StandaloneManifestRuntimeContextBuilder';
import { expandCssProperties } from './expandCSSProperties';
const areArraysEqual = (a, b) => {
  if (!a && !b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
};
const isSameDocumentPointer = (editorPointerA, editorPointerB) => editorPointerA.documentPointer.id === editorPointerB.documentPointer.id && editorPointerA.documentPointer.type === editorPointerB.documentPointer.type;

// TODO: use editor pointer API to compare
export const isSameEditorPointer = (editorPointerA, editorPointerB) => isSameDocumentPointer(editorPointerA, editorPointerB) && areArraysEqual(editorPointerA.innerElementPath, editorPointerB.innerElementPath);
const DEFAULT_RUNTIME_ID_GENERATOR = originalItemId => `${originalItemId}-sx-${hash()}`;
var _state = /*#__PURE__*/new WeakMap();
var _ManifestRuntimeContextBuilder_brand = /*#__PURE__*/new WeakSet();
export class ManifestRuntimeContextBuilder {
  constructor(manifestQueryAPI, manifestResolverAPI, manifestStore, editorPointerAPI, generateRuntimeKey) {
    if (generateRuntimeKey === void 0) {
      generateRuntimeKey = DEFAULT_RUNTIME_ID_GENERATOR;
    }
    this.manifestQueryAPI = manifestQueryAPI;
    this.manifestResolverAPI = manifestResolverAPI;
    this.manifestStore = manifestStore;
    this.editorPointerAPI = editorPointerAPI;
    this.generateRuntimeKey = generateRuntimeKey;
    _classPrivateMethodInitSpec(this, _ManifestRuntimeContextBuilder_brand);
    _classPrivateFieldInitSpec(this, _state, {
      withRuntimeMappings: false,
      isStageBound: false,
      manifests: [],
      handlers: null
    });
  }
  withRuntimeMappings(withRuntimeMappings) {
    // this.#state.withRuntimeMappings = withRuntimeMappings;
    return this;
  }

  /**
   * TODO: support both query and resolve APIs
   */
  withHandlers(cb) {
    _classPrivateFieldGet(_state, this).handlers = cb(this.manifestQueryAPI);
    return this;
  }
  isStageBound(isStageBound) {
    _classPrivateFieldGet(_state, this).isStageBound = isStageBound;
    return this;
  }
  withManifest(editorPointer, manifest) {
    const store = this.manifestStore.getByEditorPointer(editorPointer);
    _classPrivateFieldGet(_state, this).manifests.push({
      editorPointer,
      store: {
        extensionType: (store == null ? void 0 : store.extensionType) ?? ManifestComponentExtensionType.UNKNOWN,
        metadata: (store == null ? void 0 : store.metadata) ?? null,
        manifest
      }
    });
    return this;
  }
  withEditorElement(editorPointer, editorElement) {
    return this.withManifest(editorPointer, {
      editorElement
    });
  }
  withoutComponents() {
    return new StandaloneManifestRuntimeContextBuilder();
  }
  byEditorPointer(editorPointer, cb) {
    const editorElement = this.manifestStore.getManifestByEditorPointer(editorPointer) ?? getEmptyManifest().editorElement;
    const editorPointerBuilder = new ManifestRuntimeContextBuilder(this.manifestQueryAPI, this.manifestResolverAPI, this.manifestStore, this.editorPointerAPI, this.generateRuntimeKey);
    editorPointerBuilder.withRuntimeMappings(false).withEditorElement(editorPointer, editorElement);
    const context = new ManifestContextAPI(this.manifestQueryAPI, this.manifestResolverAPI, editorPointerBuilder.build(`mx-by-editor-pointer-${hash()}`), [], true);
    cb(editorElement, context);
    return this;
  }
  build(manifestId) {
    if (!_classPrivateFieldGet(_state, this).manifests.length) {
      return getEmptyManifestContext(manifestId);
    }
    const context = _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _build).call(this, _classPrivateFieldGet(_state, this).manifests);
    return {
      manifestId,
      isStageBound: _classPrivateFieldGet(_state, this).isStageBound,
      tree: {
        editorPointer: null,
        extensionType: null,
        manifest: context.manifest,
        mappings: context.mappings,
        children: _classPrivateFieldGet(_state, this).manifests.map(x => _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _buildChildren).call(this, x)).flat()
      },
      manifests: _classPrivateFieldGet(_state, this).manifests.map(x => {
        return {
          editorPointer: x.editorPointer,
          store: x.store
        };
      }),
      handlers: _classPrivateFieldGet(_state, this).handlers
    };
  }
}
function _generateItemRuntimeKey(originalItemKey) {
  /**
   * TODO: in case if withRuntimeMappings: false
   * we should not even generate and save mappings
   */
  if (!_classPrivateFieldGet(_state, this).withRuntimeMappings) {
    return originalItemKey;
  }
  return this.generateRuntimeKey(originalItemKey);
}
function _merge(extracted, merger) {
  return extracted.reduce((acc, definition) => {
    return {
      ...acc,
      [definition.runtimeKey]: merger(definition)
    };
  }, {});
}
function _mergeDefinitions(extracted) {
  return _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _merge).call(this, extracted.filter(x => !!x.definition), definition => definition.definition);
}
function _mergeMappings(extracted) {
  return _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _merge).call(this, extracted, definition => [{
    key: definition.originalKey,
    extensionType: definition.extensionType,
    editorPointer: definition.editorPointer
  }]);
}
function _extract(manifests, extractor) {
  return manifests.flatMap(_ref => {
    let {
      store,
      editorPointer
    } = _ref;
    const definitions = extractor(store.manifest);
    return Object.keys(definitions).map(itemKey => {
      return {
        runtimeKey: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _generateItemRuntimeKey).call(this, itemKey),
        originalKey: itemKey,
        editorPointer,
        extensionType: store.extensionType,
        definition: definitions[itemKey]
      };
    });
  });
}
function _build(manifests) {
  var _mainManifest$editorE;
  const extractedCssProperties = _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _extract).call(this, manifests, manifest => {
    var _manifest$editorEleme;
    const cssProperties = ((_manifest$editorEleme = manifest.editorElement) == null ? void 0 : _manifest$editorEleme.cssProperties) ?? {};
    return expandCssProperties(cssProperties);
  });

  // should be CssCustomPropertyItem
  const extractedCssCustomProperties = _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _extract).call(this, manifests, manifest => {
    var _manifest$editorEleme2;
    return ((_manifest$editorEleme2 = manifest.editorElement) == null ? void 0 : _manifest$editorEleme2.cssCustomProperties) ?? {};
  });

  // should be DataItem
  const extractedData = _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _extract).call(this, manifests, manifest => {
    var _manifest$editorEleme3;
    return ((_manifest$editorEleme3 = manifest.editorElement) == null ? void 0 : _manifest$editorEleme3.data) ?? {};
  });

  // should be DataItem
  const extractedCustomActions = _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _extract).call(this, manifests, manifest => {
    var _manifest$editorEleme4;
    return ((_manifest$editorEleme4 = manifest.editorElement) == null ? void 0 : _manifest$editorEleme4.customActions) ?? {};
  });
  const extractedPresets = _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _extract).call(this, manifests, manifest => {
    var _manifest$editorEleme5;
    return ((_manifest$editorEleme5 = manifest.editorElement) == null ? void 0 : _manifest$editorEleme5.presets) ?? {};
  });
  const extractedStates = _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _extract).call(this, manifests, manifest => {
    var _manifest$editorEleme6;
    return ((_manifest$editorEleme6 = manifest.editorElement) == null ? void 0 : _manifest$editorEleme6.states) ?? {};
  });
  const extractedActions = _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _extract).call(this, manifests, manifest => {
    var _manifest$editorEleme7;
    return (
      // @ts-expect-error xxx
      ((_manifest$editorEleme7 = manifest.editorElement) == null ? void 0 : _manifest$editorEleme7.actions) ?? {}
    );
  });
  const extractedLayout = _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _extract).call(this, manifests, manifest => {
    var _manifest$editorEleme8;
    return ((_manifest$editorEleme8 = manifest.editorElement) == null ? void 0 : _manifest$editorEleme8.layout) ?? {};
  });
  const mainManifest = manifests[0].store.manifest;
  const mainDisplayName = (_mainManifest$editorE = mainManifest.editorElement) == null ? void 0 : _mainManifest$editorE.displayName;
  return {
    manifest: {
      editorElement: {
        displayName: mainDisplayName,
        cssProperties: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeDefinitions).call(this, extractedCssProperties),
        cssCustomProperties: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeDefinitions).call(this, extractedCssCustomProperties),
        data: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeDefinitions).call(this, extractedData),
        customActions: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeDefinitions).call(this, extractedCustomActions),
        presets: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeDefinitions).call(this, extractedPresets),
        states: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeDefinitions).call(this, extractedStates),
        actions: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeDefinitions).call(this, extractedActions),
        layout: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeDefinitions).call(this, extractedLayout),
        // @ts-expect-error visibleState is available only for inlineElement or refElement
        visibleState: mainManifest.editorElement && 'visibleState' in mainManifest.editorElement ? mainManifest.editorElement.visibleState : undefined,
        displayFilters: manifests.reduce((acc, _ref2) => {
          var _store$manifest$edito;
          let {
            store
          } = _ref2;
          return {
            ...acc,
            ...((_store$manifest$edito = store.manifest.editorElement) == null ? void 0 : _store$manifest$edito.displayFilters)
          };
        }, {}),
        displayGroups: manifests.reduce((acc, _ref3) => {
          var _store$manifest$edito2;
          let {
            store
          } = _ref3;
          return {
            ...acc,
            ...((_store$manifest$edito2 = store.manifest.editorElement) == null ? void 0 : _store$manifest$edito2.displayGroups)
          };
        }, {})
      }
    },
    mappings: {
      cssProperties: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeMappings).call(this, extractedCssProperties),
      cssCustomProperties: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeMappings).call(this, extractedCssCustomProperties),
      data: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeMappings).call(this, extractedData),
      customActions: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeMappings).call(this, extractedCustomActions),
      actions: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeMappings).call(this, extractedActions),
      states: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeMappings).call(this, extractedStates),
      presets: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeMappings).call(this, extractedPresets),
      layout: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _mergeMappings).call(this, extractedLayout)
    }
  };
}
function _buildChildren(_ref4) {
  var _editorElement, _inlineElement, _refElement;
  let {
    store,
    editorPointer
  } = _ref4;
  const elements = ((_editorElement = store.manifest.editorElement) == null ? void 0 : _editorElement.elements) || ((_inlineElement = store.manifest.inlineElement) == null ? void 0 : _inlineElement.elements) || ((_refElement = store.manifest.refElement) == null || (_refElement = _refElement.resolvedElement) == null ? void 0 : _refElement.elements);
  if (!elements) {
    return [];
  }
  return Object.keys(elements).map(elementId => {
    var _element$refElement;
    const element = elements[elementId];
    if (!element) {
      return null;
    }
    const _manifest = element.inlineElement || ((_element$refElement = element.refElement) == null ? void 0 : _element$refElement.resolvedElement);

    /**
     * TODO: probably we need to check if child is visible within the current state
     * but we can't just filter it here, since it means we need to rebuild context
     * every time state is changed we need to rebuild tree
     */
    if (!_manifest) {
      return null;
    }

    // TODO: use this.editorPointerServiceAPI.buildChildPointer(editorPointer, [elementId]) instead of buildEditorPointer
    //  once we make the change to use editorPointerServiceAPI from feature store
    const childEditorPointer = this.editorPointerAPI.buildEditorPointer(this.editorPointerAPI.getDocumentPointer(editorPointer), [...(this.editorPointerAPI.getInnerElementPath(editorPointer) || ['root']), elementId]);
    return {
      ..._assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _build).call(this, [{
        editorPointer: childEditorPointer,
        store: {
          manifest: {
            editorElement: _manifest
          },
          extensionType: store.extensionType,
          metadata: store.metadata
        }
      }]),
      editorPointer: childEditorPointer,
      extensionType: store.extensionType,
      children: _assertClassBrand(_ManifestRuntimeContextBuilder_brand, this, _buildChildren).call(this, {
        editorPointer: childEditorPointer,
        store: {
          manifest: {
            editorElement: _manifest
          },
          extensionType: store.extensionType,
          metadata: store.metadata
        }
      })
    };
  }).filter(x => !!x);
}
//# sourceMappingURL=ManifestRuntimeContextBuilder.js.map